module.exports = __webpack_public_path__ + "img/Malta.e65d2b1e.png";